import { Fragment, useMemo } from 'react'
import type { MentionMediaMap } from './mentionMedia'
import { parseMentionsInText } from './mentionMedia'
import { PromptMentionChip } from './PromptMentionChip'

export function MentionAwareText({
  text,
  mediaMap,
}: {
  text: string
  mediaMap?: MentionMediaMap
}) {
  const segments = useMemo(
    () => (mediaMap ? parseMentionsInText(text, mediaMap) : null),
    [text, mediaMap],
  )
  if (!segments) return <>{text}</>
  return (
    <>
      {segments.map((seg, i) =>
        seg.type === 'text' ? (
          <Fragment key={i}>{seg.text}</Fragment>
        ) : (
          <PromptMentionChip
            key={i}
            kind={seg.kind}
            index={seg.index}
            mediaId={seg.mediaId}
          />
        ),
      )}
    </>
  )
}
